/* Prix dynamique dans les CTA d'article — SOS ORDINATEUR STORE
   Pourquoi ce script : les prix écrits EN DUR dans le corps des articles ne se
   mettent jamais à jour et finissent par mentir (4 corrigés le 07/08/2026).
   Ici le prix est lu en direct sur la fiche produit : il reste juste tout seul. */
(function () {
  if (!document.querySelector('[data-inline-cta], [data-cta-fin]')) return;

  var euro = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  var liens = document.querySelectorAll(
    '[data-inline-cta] a[href^="/products/"], [data-cta-fin] a[href^="/products/"]'
  );
  var cache = {};

  liens.forEach(function (a) {
    var handle = a.getAttribute('href').split('/products/')[1];
    if (!handle) return;
    handle = handle.split(/[?#]/)[0];
    if (a.dataset.prixPose) return;
    a.dataset.prixPose = '1';

    (cache[handle] = cache[handle] || fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
    ).then(function (p) {
      if (!p) return;                                   // produit retiré : on n'affiche rien
      var min = p.price_min, max = p.price_max;
      if (typeof min !== 'number' || min <= 0) return;
      var t = (max && max !== min ? 'dès ' : '') + euro.format(min / 100);
      var s = document.createElement('span');
      s.className = 'cta-prix';
      s.textContent = t;
      s.setAttribute('style',
        'display:inline-block;margin-left:10px;color:#0a1f44;font-weight:800;' +
        'font-size:14px;white-space:nowrap;vertical-align:middle');
      a.insertAdjacentElement('afterend', s);
    });
  });
})();
